import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { InvitesState } from './invites.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'invites', resettable: true, idKey: 'id' })
export class InvitesStore extends EntityStore<InvitesState> {
  constructor() {
    super();
  }
}
